import { render, staticRenderFns } from "./abnormalList.vue?vue&type=template&id=2d691fe7&scoped=true"
import script from "./abnormalList.vue?vue&type=script&lang=js"
export * from "./abnormalList.vue?vue&type=script&lang=js"
import style0 from "./abnormalList.vue?vue&type=style&index=0&id=2d691fe7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d691fe7",
  null
  
)

export default component.exports